exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nfieldset[data-v-34b0770b] {\n\ttext-align: center;\n}\ninput[type=submit][data-v-34b0770b] {\n\tmargin-top: 20px;\n}\n", ""]);
